/**
 * External Imports
 */
import { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Internal Imports
 */
import MyEmployeeListTable from '../../components/customTables/account/myEmployeeListTable';
import MyDelegatesListTable from '../../components/customTables/account/myDelegatesTable';
import DelegatedToMeTable from '../../components/customTables/account/delegatedToMeTable';
import AccountSideNav from '../../components/sideNav/accountSideNav/AccountSideNav';
import AdhocListTable from '../../components/customTables/account/adhocListTable/AdhocListTable';
import {
  CSCListSettingsTable,
  CNEdListSettingsTable,
  NLRListSettingsTable,
  AIDETListSettingsTable,
  BSSRListSettingsTable
} from '../../components/customTables/account/supportListSettingsTables';
import NoDataSplashView from '../../components/shared/table/noDataSplashView';

/**
 * Style Imports
 */
import { ContentContainer } from './Account.styles';

const EmployeeRoundingSettings: FC<{}> = () => {
  const { empRoundSettingsTable = 'employee-list' } = useParams();

  const currentlySelectedSettingsTable = useMemo(() => {
    switch (empRoundSettingsTable) {
      case 'employee-list':
        return <MyEmployeeListTable />;
      case 'delegate-list':
        return <MyDelegatesListTable />;
      case 'delegated-to-me':
        return <DelegatedToMeTable />;
      case 'adhoc-list':
        return <AdhocListTable />;
      case 'csc-list':
        return <CSCListSettingsTable />;
      case 'cned-list':
        return <CNEdListSettingsTable />;
      case 'nlr-list':
        return <NLRListSettingsTable />;
      case 'aidet-list':
        return <AIDETListSettingsTable />;
      case 'bssr-list':
        return <BSSRListSettingsTable />;
      default:
        return <NoDataSplashView type="" />;
    }
  }, [empRoundSettingsTable]);

  return (
    <ContentContainer id="Employee-Rounding-Settings">
      <AccountSideNav />
      {currentlySelectedSettingsTable}
    </ContentContainer>
  );
};

export default EmployeeRoundingSettings;
